export default () => `
  <div class="content">
    Contact your local building department to obtain rain load.
  </div>
`;
